'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var get = _interopDefault(require('lodash/get'));
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
var sharedComponents = require('../shared-components.js');
var style = require('../style-cf128dc7.js');
var isRegExp = _interopDefault(require('lodash/isRegExp'));
var replace = _interopDefault(require('lodash/replace'));

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  height: ", ";\n  ", ";\n  padding: 0px 10px;\n"], ["\n  ", ";\n  height: ", ";\n  ", ";\n  padding: 0px 10px;\n"]);

var StyledInput = styled__default.input(_templateObject, style.commonInputStyle, function (props) {
  return props.height ? "" + props.height : "40px";
}, function (props) {
  return props.inputStyle;
});

/**
 * The PreventInputTextField component
 * @param {String} label the text to show above the text field
 * @param {Boolean} isRequired the isRequired status to show * sign
 * @param {Boolean} disabled the disabled status to disable the input text field
 * @param {String} error the text to show below the text field when has error
 * @param {String} width the width of input text field
 * @param {String} height the height of input text field
 * @param {String} textColor the color of label
 * @param {Object} labelStyle the style for label component
 * @param {Object} inputStyle the style for input text field component
 * @param {Object} ErrorMessageStyle the style for error message
 */

/* eslint-disable react/prefer-stateless-function */

var PreventInput = function (_Component) {
  _babelHelpers.inherits(PreventInput, _Component);

  function PreventInput() {
    _babelHelpers.classCallCheck(this, PreventInput);

    var _this = _babelHelpers.possibleConstructorReturn(this, (PreventInput.__proto__ || Object.getPrototypeOf(PreventInput)).call(this));

    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(PreventInput, [{
    key: "onChange",
    value: function onChange(e) {
      var onChange = this.props.onChange;

      this.handleValue(onChange, e);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var onBlur = this.props.onBlur;

      this.handleValue(onBlur, e);
    }
  }, {
    key: "handleValue",
    value: function handleValue(func, e) {
      var regex = this.props.regex;

      var value = get(e, "target.value");
      if (value && isRegExp(regex)) {
        e.target.value = replace(value, regex, "");
      }
      func(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          label = _props.label,
          isRequired = _props.isRequired,
          disabled = _props.disabled,
          error = _props.error,
          labelStyle = _props.labelStyle,
          inputStyle = _props.inputStyle,
          textColor = _props.textColor,
          ErrorMessageStyle = _props.ErrorMessageStyle,
          mb = _props.mb,
          onChange = _props.onChange,
          rest = _babelHelpers.objectWithoutProperties(_props, ["label", "isRequired", "disabled", "error", "labelStyle", "inputStyle", "textColor", "ErrorMessageStyle", "mb", "onChange"]);

      return React__default.createElement(
        sharedComponents.InputGroup,
        { mb: mb },
        React__default.createElement(
          sharedComponents.StyledLabel,
          {
            textColor: textColor,
            labelStyle: labelStyle,
            disabled: disabled },
          label,
          isRequired && React__default.createElement(
            sharedComponents.RedText,
            { disabled: disabled },
            " *"
          )
        ),
        React__default.createElement(StyledInput, _babelHelpers._extends({
          error: error,
          style: inputStyle,
          disabled: disabled,
          onChange: this.onChange,
          onBlur: this.onBlur
        }, rest)),
        error && React__default.createElement(
          sharedComponents.ErrorMessage,
          { ErrorMessageStyle: ErrorMessageStyle },
          error
        )
      );
    }
  }]);
  return PreventInput;
}(React.Component);

PreventInput.propTypes = {
  /** component id */
  id: PropTypes.string.isRequired,
  /** text to display */
  label: PropTypes.string,
  /** indicator to display red sign */
  isRequired: PropTypes.bool,
  /** indicator to display disable input */
  disabled: PropTypes.bool,
  /** error message to display under input */
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** input width */
  width: PropTypes.string,
  /** input height */
  height: PropTypes.string,
  /** text color of label */
  textColor: PropTypes.string,
  /** style to override label component */
  labelStyle: PropTypes.object,
  /** style to override input component */
  inputStyle: PropTypes.object,
  /** style to override error message component */
  ErrorMessageStyle: PropTypes.object,
  /** regex /[0-9]/g */
  regex: PropTypes.any.isRequired
};
PreventInput.__docgenInfo = {
  "description": "The PreventInputTextField component\n@param {String} label the text to show above the text field\n@param {Boolean} isRequired the isRequired status to show * sign\n@param {Boolean} disabled the disabled status to disable the input text field\n@param {String} error the text to show below the text field when has error\n@param {String} width the width of input text field\n@param {String} height the height of input text field\n@param {String} textColor the color of label\n@param {Object} labelStyle the style for label component\n@param {Object} inputStyle the style for input text field component\n@param {Object} ErrorMessageStyle the style for error message",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleValue",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "func",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "PreventInput",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display"
    },
    "isRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display red sign"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disable input"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "error message to display under input"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "input width"
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "input height"
    },
    "textColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text color of label"
    },
    "labelStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override label component"
    },
    "inputStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override input component"
    },
    "ErrorMessageStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override error message component"
    },
    "regex": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "regex /[0-9]/g"
    }
  }
};

exports.StyledInput = StyledInput;
exports.default = PreventInput;
//# sourceMappingURL=prevent.js.map
